/**
 * Simple logger utility
 * @param {string} namespace - Logger namespace
 * @returns {Object} Logger object with debug, info, warn, error methods
 */
const createLogger = (namespace) => {
  const logWithLevel = (level) => (...args) => {
    if (import.meta.env.DEV) {
      console[level](`[${namespace}]`, ...args);
    }
  };

  return {
    debug: logWithLevel('debug'),
    info: logWithLevel('info'),
    warn: logWithLevel('warn'),
    error: logWithLevel('error'),
  };
};

export default createLogger;
